export default [{
  key: 'silhouette',
  seo_slug: 'silhouette',
  values: [{
    seo_slug: 'a-line',
    value: 'a-line'
  }, {
    seo_slug: 'ball-gown',
    value: 'ball-gown'
  }, {
    seo_slug: 'column',
    value: 'column'
  }, {
    seo_slug: 'fit-and-flare',
    value: 'fit-and-flare'
  }, {
    seo_slug: 'jumpsuit',
    value: 'jumpsuit'
  }, {
    seo_slug: 'mermaid',
    value: 'mermaid'
  }, {
    seo_slug: 'pantsuit',
    value: 'pantsuit'
  }, {
    seo_slug: 'sheath',
    value: 'sheath'
  }, {
    seo_slug: 'slip',
    value: 'slip'
  }]
}, {
  key: 'neckline',
  seo_slug: 'neckline',
  values: [{
    seo_slug: 'bateau',
    value: 'bateau'
  }, {
    seo_slug: 'cowl-neck',
    value: 'cowl-neck'
  }, {
    seo_slug: 'halter',
    value: 'halter'
  }, {
    seo_slug: 'high-neck',
    value: 'high-neck'
  }, {
    seo_slug: 'illusion-neckline',
    value: 'illusion'
  }, {
    seo_slug: 'off-the-shoulder',
    value: 'off-the-shoulder'
  }, {
    seo_slug: 'one-shoulder',
    value: 'one-shoulder'
  }, {
    seo_slug: 'queen-anne-neck',
    value: 'queen-anne-neck'
  }, {
    seo_slug: 'scoop',
    value: 'scoop'
  }, {
    seo_slug: 'square',
    value: 'square'
  }, {
    seo_slug: 'straight-neck',
    value: 'straight-neck'
  }, {
    seo_slug: 'sweetheart',
    value: 'sweetheart'
  }, {
    seo_slug: 'v-neck',
    value: 'v-neck'
  }]
}, {
  key: 'sleeves',
  seo_slug: 'sleeves',
  values: [{
    seo_slug: 'cap-sleeve',
    value: 'cap_sleeves'
  }, {
    seo_slug: 'detachable-sleeve',
    value: 'detachable_sleeve'
  }, {
    seo_slug: 'illusion-sleeve',
    value: 'illusion_sleeve'
  }, {
    seo_slug: 'long-sleeve',
    value: 'long_sleeve'
  }, {
    seo_slug: 'puff-sleeve',
    value: 'puff_sleeve'
  }, {
    seo_slug: 'short-sleeve',
    value: 'short_sleeve'
  }, {
    seo_slug: 'sleeveless',
    value: 'sleeveless'
  }, {
    seo_slug: 'spaghetti-strap',
    value: 'spaghetti_strap'
  }, {
    seo_slug: 'strapless',
    value: 'strapless'
  }]
}, {
  key: 'gownLength',
  seo_slug: 'gownLength',
  values: [{
    seo_slug: 'floor-length',
    value: 'floor'
  }, {
    seo_slug: 'high-low',
    value: 'high-low'
  }, {
    seo_slug: 'midi',
    value: 'midi'
  }, {
    seo_slug: 'short',
    value: 'short'
  }, {
    seo_slug: 'tea-length',
    value: 'tea'
  }]
}, {
  key: 'pricePoint',
  seo_slug: 'pricePoint',
  values: [{
    seo_slug: 'under-200',
    value: 'Under$200'
  }, {
    seo_slug: '250-499',
    value: '$250-$499'
  }, {
    seo_slug: '500-999',
    value: '$500-$999'
  }, {
    seo_slug: '1000-1499',
    value: '$1000-$1499'
  }, {
    seo_slug: '1500-1999',
    value: '$1500-$1999'
  }, {
    seo_slug: '2000-2499',
    value: '$2000-$2499'
  }, {
    seo_slug: '2500-2999',
    value: '$2500-$2999'
  }, {
    seo_slug: '3000-3999',
    value: '$3000-$3999'
  }, {
    seo_slug: '4000-4999',
    value: '$4000-$4999'
  }, {
    seo_slug: '5000-5999',
    value: '$5000-$5999'
  }, {
    seo_slug: '6000-6999',
    value: '$6000-$6999'
  }, {
    seo_slug: '7000-7999',
    value: '$7000-$7999'
  }, {
    seo_slug: '8000-8999',
    value: '$8000-$8999'
  }, {
    seo_slug: '9000-9999',
    value: '$9000-$9999'
  }, {
    seo_slug: '10000',
    value: '$10,000+'
  }]
}];